import stickerList from './stickerList.json';
import parseBrandingColors from './parseBrandingColors';
import ImageLibrary from './ImageLibrary';
import { Undo, Redo } from './PhotoEditorUndoRedo';

export default function (container, imageSrc, browser) {
    return new Promise((resolve, reject) => {
        (async () => {
            try {
                const tools = [
                    'library',
                    'transform',
                    'filter',
                    'adjustment',
                    'focus',
                    'text',
                    'textdesign',
                    'sticker',
                    'brush',
                    'frame',
                    'overlay',
                ];
                const editorOptions = browser === 'ie' ? tools.slice(1) : tools;
                const { stickers } = stickerList;
                const options = {
                    title: 'Staffbase Email Designer Image Editor',
                    container,
                    image: imageSrc,
                    custom: {
                        languages: {
                            en: {
                                mainCanvasActions: {
                                    buttonExport: 'Save',
                                    buttonUndo: 'Undo',
                                    buttonRedo: 'Redo',
                                    buttonClose: 'Cancel',
                                },
                                library: {
                                    title: 'Library',
                                    controls: {
                                        buttonUpload: 'Upload Image',
                                        buttonWebcamOpen: 'Open Webcam',
                                        buttonWebcamClose: 'Close Webcam',
                                        placeholderSearch: 'Search Library',
                                        noResults: 'No Results',
                                    },
                                },
                                transform: {
                                    title: 'Crop',
                                },
                            },
                        },
                        components: {
                            buttons: {
                                mainCanvasActionUndo: Undo,
                                mainCanvasActionRedo: Redo,
                            },
                        },
                        themes: {
                            light: {
                                primary: '#0277BD',
                                button: {
                                    containedPrimaryBackground: '#0277BD',
                                    containedPrimaryForeground: 'white',
                                    outlinedPrimaryBackground: 'white',
                                    outlinedPrimaryForeground: '#0277BD',
                                    outlinedSecondaryBackground: 'white',
                                    outlinedSecondaryForeground: '#0277BD',
                                    outlinedInactiveOverlayColor: 'rgba(0, 0, 0, 0)',
                                    outlinedBorderColor: '#0277BD',
                                    textPrimaryForeground: '#0277BD',
                                    textSecondaryForeground: '#424242',
                                    textInactiveOpacity: '0.5',
                                    activeForeground: '#0277BD',
                                    hoverOverlayColor: 'rgba(255, 255, 255, 0.08)',
                                },
                                canvas: {
                                    controlsOutline: '#0277BD',
                                    controlsColor: '#0277BD',
                                },
                                checkbox: {
                                    background: '#FFFFFF',
                                    foreground: '#FFFFFF',
                                    activeForeground: '#FFFFFF',
                                    activeBackground: '#0277BD',
                                    inactiveOpacity: '0.3',
                                    hoverOpacity: '0.8',
                                },
                                trackColor: '#DADFE4',
                                activeTrackColor: '#0277BD',
                                thumbBackground: '#F7F9FA',
                                thumbBorderColor: '#0277BD',
                                inactiveOpacity: '0.3',
                                hoverOpacity: '0.7',
                                toolbar: {
                                    foreground: 'rgba(255, 255, 255, 0.90)',
                                    background: '#FFFFF',
                                    activeBackground: 'transparent',
                                    activeForeground: '#0277BD',
                                    borderColor: 'transparent',
                                    border: 'none',
                                },
                                typography: {
                                    fontURI:
                                        "'https://app-data-legacy.bananatag.com/corporate-fonts/CerebriSansPro-Bold.woff2'", // font path relative to font assets
                                    fontFamily: "'Cerebri Sans Pro'",
                                    format: 'woff',
                                    provider: 'file',
                                    // Most users load font while initializing their app,
                                    // In that case, you can choose to skip loading it again
                                    skipLoading: false,
                                },
                                shape: {
                                    radiusSmall: 2,
                                    radiusMedium: 0,
                                    radiusLarge: 0,
                                },
                                tooltip: {
                                    background: '#D9DADB',
                                },
                            },
                        },
                    },
                    license:
                        '{"owner":"Bananatag","version":"2.1","enterprise_license":false,"available_actions":["magic","filter","transform","sticker","text","adjustments","brush","focus","frames","camera"],"features":["adjustment","filter","focus","overlay","transform","text","sticker","frame","brush","camera","library","export"],"platform":"HTML5","app_identifiers":[],"api_token":"ddC8h4ha8la5I00pPltigw","domains":["https://api.photoeditorsdk.com"],"issued_at":1528393178,"expires_at":null,"signature":"YrXFgCaDiG/xospAjue8LHBB2GUKS0+Fl02fG8w5IMcSPQtSYmNSVR9L19RkHD7noql2SSa0H6ZwQ1C9zbUFuvA4Nzt1qATcRzCOpTcuQCTZBV9fgk2ugn6UB846RFTpHb/NA03Z1pSaWo2XIuFhu7rNZpynox/Gt0meJWlliPCVAKzerYQbIAOkiEpmqZ3vk7joHXP7Qimwr2bRXC8rK6+86vBgY3zMXk/luAoquO0ghhBdCGME1rxBHYNCBm595WiXlLej537iy0MBvm+8/y8Sgn9A4yV3Dk6qsWTYaOrbQ7y6oUyTM1qirh8/09nXG/vBAbgJa5HSrczIDq2um7rvR2dH/CvZ2DBjXrXT4tFcXIavsf/S1vMGTmGHGlvsrrUnkW4jSSRrMzqWuQ+JtIJHpkYRJVpo5g8fB/2lWDBUSZW37gpdh3v46sZ6bkLpsAQqDW3aZmADTmdO+C40pTz2UbZooQuvMEbJTUcXrYMujEr78v3SnqWxr1vBpJhOoSfYbDGV6KXN9rnMhnu8Io+ZWAOSY9Dj7VJwlPF4kBMViPPvlFwGo88AvmDM9m1o6PR3ingwNHwCbPfVuBQ8HTCK2ev1gGZILQ2RHayyI/PY8LttqSQY0fNLi76yP89t2diNFv67/2eBd3s5fayKrNPUzNqEp2gY6TyuHB1TfMs="}',
                    layout: 'advanced',
                    defaultTool: 'transform',
                    displayCloseWarning: 'false',
                    assetBaseUrl: `${process.env.PUBLIC_URL}/pesdk/V5/assets`,
                    preloader: true,
                    engine: {
                        crossOrigin: 'anonymous',
                    },
                    text: {
                        fonts: [
                            { identifier: 'imgly_font_open_sans_bold' },
                            { identifier: 'imgly_font_aleo_bold' },
                            { identifier: 'imgly_font_amaticsc' },
                            { identifier: 'imgly_font_bernier_regular' },
                            { identifier: 'imgly_font_cheque_regular' },
                            { identifier: 'imgly_font_gagalin_regular' },
                            { identifier: 'imgly_font_hagin_caps_thin' },
                            { identifier: 'imgly_font_intro_inline' },
                            { identifier: 'imgly_font_lobster' },
                            { identifier: 'imgly_font_nexa_script' },
                            { identifier: 'imgly_font_ostrich_sans_black' },
                            { identifier: 'imgly_font_ostrich_sans_bold' },
                            {
                                identifier: 'imgly_font_panton_blackitalic_caps',
                            },
                            {
                                identifier: 'imgly_font_panton_lightitalic_caps',
                            },
                            { identifier: 'imgly_font_perfograma' },
                            { identifier: 'imgly_font_trash_hand' },
                            {
                                identifier: 'sb_helvetica',
                                fontFamily: 'Helvetica',
                                fontWeight: 400,
                                textMetrics: {
                                    unitsPerEm: 2048,
                                    ascender: 1577,
                                    descender: -471,
                                },
                                fontURI: './custom_fonts/sb_helvetica.ttf', // path to the font, relative to the font asset directory
                                format: 'truetype',
                                provider: 'file'
                            },
                            {
                                identifier: 'sb_arial',
                                fontFamily: 'Arial',
                                fontWeight: 400,
                                textMetrics: {
                                    unitsPerEm: 2048,
                                    ascender: 1854,
                                    descender: -434,
                                },
                                fontURI: './custom_fonts/sb_arial.ttf', // path to the font, relative to the font asset directory
                                format: 'truetype',
                                provider: 'file'
                            },
                        ],
                        colors: parseBrandingColors(),
                        backgroundColors: parseBrandingColors().length
                            ? [...parseBrandingColors(), { color: [0, 0, 0, 0], name: 'Transparent' }]
                            : [],
                    },
                    transform: {
                        categories: [
                            {
                                identifier: 'imgly_transforms_common',
                                items: [
                                    {
                                        identifier: 'imgly_transform_common_custom',
                                        thumbnailURI: 'custom.svg',
                                    },
                                    {
                                        identifier: 'imgly_transform_common_square',
                                        thumbnailURI: 'square.svg',
                                    },
                                    {
                                        identifier: 'imgly_transform_common_4',
                                        thumbnailURI: '4-3.svg',
                                    },
                                    {
                                        identifier: 'imgly_transform_common_16',
                                        thumbnailURI: '16-9.svg',
                                    },
                                    {
                                        identifier: 'imgly_transform_common_3',
                                        thumbnailURI: '3-4.svg',
                                    },
                                    {
                                        identifier: 'imgly_transform_common_9',
                                        thumbnailURI: '9-16.svg',
                                    },
                                ],
                            },
                        ],
                        flattenCategories: false,
                    },
                    forceCrop: false,
                    enableZoom: true,
                    enableUpload: true,
                    tools: editorOptions,
                    export: {
                        image: {
                            enableDownload: false,
                            preventExportEvent: true,
                            exportType: 'data-url',
                        },
                    },
                    theme: 'light',
                    library: {
                        provider: ImageLibrary,
                        enableUpload: true,
                        enableWebcam: false,
                    },
                    sticker: {
                        categories: [
                            { identifier: 'imgly_sticker_shapes' },
                            {
                                identifier: 'bananatag_category',
                                name: 'Custom Stickers',
                                thumbnailURI: 'btag/background.png',
                                items: stickers,
                            },
                            { identifier: 'imgly_sticker_emoticons' },
                        ],
                        colors: parseBrandingColors(),
                    },
                    frame: {
                        items: [
                            {
                                identifier: 'btag_simple_frame',
                                name: 'Simple',
                                thumbnailURI: 'btag_simple/thumb/simple.png',
                                layoutMode: 'vertical-inside',
                                tintable: true,
                                imageGroups: {
                                    top: {
                                        mid: 'btag_simple/base/top_mid.png',
                                    },
                                    left: {
                                        start: 'btag_simple/base/left_start.png',
                                        mid: 'btag_simple/base/left_mid.png',
                                        end: 'btag_simple/base/left_end.png',
                                    },
                                    right: {
                                        start: 'btag_simple/base/right_start.png',
                                        mid: 'btag_simple/base/right_mid.png',
                                        end: 'btag_simple/base/right_end.png',
                                    },
                                    bottom: {
                                        mid: 'btag_simple/base/bottom_mid.png',
                                    },
                                },
                            },
                            {
                                identifier: 'btag_rounded_rectangle',
                                name: 'Soft Corners',
                                thumbnailURI: 'btag_rounded_rectangle/thumb/soft_corners.png',
                                layoutMode: 'vertical-inside',
                                tintable: true,
                                imageGroups: {
                                    top: {
                                        mid: 'btag_rounded_rectangle/base/top_mid.png',
                                    },
                                    left: {
                                        start: 'btag_rounded_rectangle/base/left_start.png',
                                        mid: 'btag_rounded_rectangle/base/left_mid.png',
                                        end: 'btag_rounded_rectangle/base/left_end.png',
                                    },
                                    right: {
                                        start: 'btag_rounded_rectangle/base/right_start.png',
                                        mid: 'btag_rounded_rectangle/base/right_mid.png',
                                        end: 'btag_rounded_rectangle/base/right_end.png',
                                    },
                                    bottom: {
                                        mid: 'btag_rounded_rectangle/base/bottom_mid.png',
                                    },
                                },
                            },
                            {
                                identifier: 'btag_dashed',
                                name: 'Dashed',
                                thumbnailURI: 'btag_dashed/thumb/thumb_dashed.png',
                                layoutMode: 'vertical-inside',
                                tintable: true,
                                imageGroups: {
                                    top: {
                                        mid: {
                                            image: 'btag_dashed/base/top_mid.png',
                                            mode: 'repeat',
                                        },
                                    },
                                    left: {
                                        start: 'btag_dashed/base/left_start.png',
                                        mid: {
                                            image: 'btag_dashed/base/left_mid.png',
                                            mode: 'repeat',
                                        },
                                        end: 'btag_dashed/base/left_end.png',
                                    },
                                    right: {
                                        start: 'btag_dashed/base/right_start.png',
                                        mid: {
                                            image: 'btag_dashed/base/right_mid.png',
                                            mode: 'repeat',
                                        },
                                        end: 'btag_dashed/base/right_end.png',
                                    },
                                    bottom: {
                                        mid: {
                                            image: 'btag_dashed/base/bottom_mid.png',
                                            mode: 'repeat',
                                        },
                                    },
                                },
                            },
                            {
                                identifier: 'btag_circle',
                                name: 'Circle',
                                thumbnailURI: 'btag_circle/thumb/thumb_circle.svg',
                                layoutMode: 'vertical-inside',
                                tintable: true,
                                imageGroups: {
                                    top: {
                                        mid: 'btag_circle/base/top_mid.svg',
                                    },
                                    left: {
                                        start: 'btag_circle/base/left_start.svg',
                                        mid: 'btag_circle/base/left_mid.svg',
                                        end: 'btag_circle/base/left_end.svg',
                                    },
                                    right: {
                                        start: 'btag_circle/base/right_start.svg',
                                        mid: 'btag_circle/base/right_mid.svg',
                                        end: 'btag_circle/base/right_end.svg',
                                    },
                                    bottom: {
                                        mid: 'btag_circle/base/bottom_mid.svg',
                                    },
                                },
                            },
                            { identifier: 'imgly_frame_dia' },
                            { identifier: 'imgly_frame_art_decor' },
                            { identifier: 'imgly_frame_black_passepartout' },
                            { identifier: 'imgly_frame_wood_passepartout' },
                            { identifier: 'imgly_frame_lowpoly_shadow' },
                        ],
                    },
                    brush: {
                        colors: parseBrandingColors(),
                    },
                    displayResizeWarning: false,
                };
                resolve(options);
            } catch (err) {
                reject(err);
            }
        })();
    });
}
